import { Collection } from '../lib/collection';

export const Errors = new Collection('errors');
